<template>
  <!-- Conteúdo do slide -->
  <div v-if="slider.length" class="slider-area position-relative">
    <div v-for="(slide, index) in slider" :key="index" :class="['slide', { active: index === currentIndex }]"
      class="single-sliders slider-height slider-bg1 d-flex align-items-center">
      <div class="container">
        <div class="row align-items-center">
          <!-- textos -->
          <div class="col-xxl-5 col-xl-5 col-lg-5 col-md-6 textos-slide-avance">
            <div class="hero-caption text-center">
              <h1>{{ slide.itiNome }}</h1>
              <p>{{ slide.itiReferencia }}</p>
              <p><router-link class="btn hero-btn" :to="slide.itiLinkBtn1">{{ slide.itiTextoBtn1 }}</router-link>
              </p>
            </div>
          </div>
          <!-- imagem -->
          <div class="col-xl-5 col-lg-5 col-md-6">
            <div class="hero-shape">
              <img v-if="slide.insInstitucionalImagens[0].itgUrlImagem"
                :src="$imgURL + slide.insInstitucionalImagens[0].itgUrlImagem" :alt="`Imagem ${index + 1}`"
                class="slide-image" />
            </div>
          </div>

        </div>
        <!-- Navegação -->
      <div class="navigation-avance">
        <span v-for="(slide, index) in slider" :key="index" :class="['dot', { active: index === currentIndex }]"
          @click="goToSlide(index)"></span>
      </div>
      </div>
      
    </div>
  </div>
  <!-- END conteúdo slide -->

</template>

<script>
import axios from 'axios';

export default {
  name: "PageSlider",
  data() {
    return {
      slider: [],
      currentIndex: 0,
      interval: null,
    };
  },
  mounted() {
    this.fetchSlides();
    this.startSlider();
  },
  beforeUnmount() {
    clearInterval(this.interval);
  },
  methods: {
    startSlider() {
      this.interval = setInterval(() => {
        this.nextSlide();
      }, 7000);
    },
    nextSlide() {
      this.currentIndex = (this.currentIndex + 1) % this.slider.length;
    },
    goToSlide(index) {
      clearInterval(this.interval);
      this.currentIndex = index;
      this.startSlider();
    },
    async fetchSlides() {
      try {
        const response = await axios.get('/Process/InsInstitucional/institucional/34/slides/0/x');
        this.slider = response.data.sort((a, b) => (parseInt(a.itiOrdem) || 0) - (parseInt(b.itiOrdem) || 0));
      } catch (error) {
        console.error(error);
      }
      //console.log('slide')
      //console.log(this.slider)
    }
  }
};
</script>

<style scoped>
.slider-height {
  height: 600px;
}
@media (max-width: 767px) {
  .slider-height {
  height: 400px;
}
}

.slider {
  position: relative;
  width: 100%;
  overflow: hidden;
  margin-top: 75px;
}

.slides {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.slide {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  opacity: 0;
  position: absolute;
  transition: opacity 1s ease;
}

.slide.active {
  opacity: 1;
  position: relative;
}

/*-- imagem do slide --*/
.slide-image {
  width: 100%;
  max-height: 450px;
  object-fit: cover;
}

.caption {
  position: absolute;
  top: 200px;
  right: 250px;
  color: white;
  width: 700px;
}

.navigation-avance {
  text-align: left;
  margin-left: 20px;
  position: absolute;
  bottom: 10px;
  width: 100%;
}

.dot {
  display: inline-block;
  height: 10px;
  width: 20px;
  margin: 0 5px;
  background-color: #D9B046;
  border-radius: 5px;
  cursor: pointer;
}

.dot.active {
  background-color: #ffffff;
  width: 20px;
}

.textos-slide-avance {
  padding-top: 100px;
}
@media (max-width: 767px) {
  .textos-slide-avance {
  padding-top: 10px;
}
}

@media (max-width: 767px) {
  .caption {
    right: 20px;
    font-size: 12px;
    width: 350px;
    padding: 10px;
    top: 60px;
    color: white;
  }

  .caption p {
    color: white;
  }

  .untree_co--hero .intro p {
    color: #ffffff;
  }

  .dot {
    width: 18px;
    height: 5px;
  }

  .dot.active {
    background-color: #e2e2e2;
    width: 15px;
  }

  .slide-image {
    width: 100%;
    max-height: 500px;
    object-fit: cover;
  }

  .untree_co--hero,
  .untree_co--hero>.container>.row {
    height: 30vh;
    min-height: 50px;
  }
}

@media (max-width: 991.98px) {
  .untree_co--hero .intro p {
    color: #ffffff !important;
  }
}
</style>
